import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "flex-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-semibold my-6 text-center" }
const _hoisted_6 = { class: "form-field-floating xl reactive active rounded-50 text-center mt-6" }
const _hoisted_7 = { class: "flex gap-4 mb-7" }
const _hoisted_8 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "flex-center gap-6" }
const _hoisted_11 = { class: "text-sm text-grey-600 text-center position-absolute bottom mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.userPhoto || '/public/assets/users/300w/user.jpg',
          class: "rounded-100 overflow-hidden size-4xl item active",
          alt: "Photo de profil"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.userName || 'Connexion'), 1),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input text-center",
            name: "identifiant",
            id: "identifiant",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.identifiant) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.identifiant]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "identifiant" }, [
            _createTextVNode("Email ou numéro de téléphone "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "font-normal text-grey-600 text-center mt-5 mb-3" }, " Entrez votre code de sécurité ", -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.securityCode, (digit, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
              key: index,
              type: "password",
              class: "form-control-code",
              id: `code-${index}`,
              "onUpdate:modelValue": ($event: any) => ((_ctx.securityCode[index]) = $event),
              maxlength: "1",
              onInput: ($event: any) => (_ctx.handleInput(index, $event)),
              onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event)),
              onPaste: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
              placeholder: "",
              inputmode: "numeric",
              pattern: "[0-9]"
            }, null, 40, _hoisted_8)), [
              [_vModelText, _ctx.securityCode[index]]
            ])
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5 mb-7",
          disabled: !_ctx.isFormValid || _ctx.isSubmitting
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: "/public/icons/icon-menu-securite.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Connexion...' : 'Connexion'), 1)
        ], 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, { to: "/forget-password" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("h5", { class: "text-primary-color text-center" }, "Besoin d'aide ?", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/signup" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("h5", { class: "text-primary-color text-center" }, "Créer un compte !", -1)
            ]))]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _createElementVNode("p", _hoisted_11, [
      _cache[9] || (_cache[9] = _createTextVNode(" © Tous droits réservés COOP FINANCE 2026   ", -1)),
      _createVNode(_component_router_link, { to: "/aide" }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("Besoin d'aide ?", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}